import styled from "styled-components";
import Colors from "../../constants/Colors";

export const FormContainer = styled.div<{isConfirmationState?: boolean}>`
    padding: ${props=>props.isConfirmationState? '40px':''};
    background-color: ${props=>props.isConfirmationState? Colors.GRAY50:''};
    border: ${props=>props.isConfirmationState? `1px solid ${Colors.GRAY200}`:''};
    border-radius: ${props=>props.isConfirmationState? '8px':''};
    
`